/* Reproductor de música flotante */
(function () {
  if (customElements.get('music-player')) return;

  class MusicPlayer extends HTMLElement {
    connectedCallback() {
      this.btn = this.querySelector('[data-toggle]');
      this.iconPlay = this.querySelector('.af-mp__icon--play');
      this.iconPause = this.querySelector('.af-mp__icon--pause');
      if (!this.btn || !this.dataset.src) return;

      this.key = this.dataset.key || 'af-music';
      this.audio = new Audio(this.dataset.src);
      this.audio.loop = this.dataset.loop === 'true';
      this.audio.volume = Math.min(1, Math.max(0, (parseInt(this.dataset.volume, 10) || 50) / 100));
      this.audio.preload = 'none';

      this.btn.addEventListener('click', () => this.toggle());
      this.audio.addEventListener('play', () => this.paint(true));
      this.audio.addEventListener('pause', () => this.paint(false));

      // Continuar tras cambiar de página, solo si el usuario ya había interactuado
      if (this.dataset.remember === 'true' && this.wasPlaying()) {
        this.audio.play().catch(() => { this.remember(false); });
      }
    }

    disconnectedCallback() {
      if (this.audio) { this.audio.pause(); this.audio.src = ''; }
    }

    wasPlaying() {
      try { return sessionStorage.getItem(this.key) === '1'; } catch (e) { return false; }
    }

    remember(v) {
      try { sessionStorage.setItem(this.key, v ? '1' : '0'); } catch (e) {}
    }

    toggle() {
      if (this.audio.paused) {
        this.audio.play().catch(() => {});
      } else {
        this.audio.pause();
      }
    }

    paint(playing) {
      if (this.iconPlay) this.iconPlay.hidden = playing;
      if (this.iconPause) this.iconPause.hidden = !playing;
      this.btn.setAttribute('aria-pressed', playing ? 'true' : 'false');
      const label = playing ? this.btn.dataset.labelPause : this.btn.dataset.labelPlay;
      if (label) this.btn.setAttribute('aria-label', label);
      if (this.dataset.remember === 'true') this.remember(playing);
    }
  }

  customElements.define('music-player', MusicPlayer);
})();
